export default __webpack_public_path__ + "static/media/main-bottomimg3.51b1ce1f.png";